import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { teamMembers } from "@/i18n/translations";
import ScrollReveal from "@/components/ScrollReveal";
import Marquee from "@/components/Marquee";
import AboutHero from "@/components/hero/AboutHero";

const About = () => {
  const { t, lang } = useLang();

  return (
    <main data-testid="about-page" className="bg-brand-bg text-white pt-32">
      <AboutHero />

      <Marquee items={t.marquee} variant="glass" />

      <section className="py-24 md:py-32 border-b border-brand-border">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-brand-purpleLight mb-4">
              {t.about.manifestoTitle}
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-black uppercase leading-[0.95] tracking-tighter">
              {lang === "bg" ? (
                <>Във какво <span className="text-white">вярваме</span></>
              ) : (
                <>What we <span className="text-white">stand for</span></>
              )}
            </h2>
          </div>
          <ul className="lg:col-span-8 divide-y divide-brand-border border-y border-brand-border">
            {t.about.manifesto.map((m, i) => (
              <ScrollReveal key={i} delay={i * 80} as="li" className="py-6 md:py-8 grid grid-cols-12 gap-6 items-start">
                <span className="col-span-2 font-mono text-xs uppercase tracking-[0.25em] text-brand-purpleLight">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="col-span-10 font-heading text-xl md:text-3xl font-bold leading-tight tracking-tight">
                  {m}
                </p>
              </ScrollReveal>
            ))}
          </ul>
        </div>
      </section>

      <section className="relative py-24 md:py-32 border-b border-brand-border bg-brand-bgSecond overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="orb orb-pink w-[500px] h-[500px] -top-32 right-0 opacity-15 animate-float-slow" />
        </div>
        <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="mb-16">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-brand-purpleLight mb-4">
              {t.about.teamTag}
            </p>
            <h2 className="font-heading text-4xl md:text-6xl font-black uppercase leading-[0.95] tracking-tighter">
              {lang === "bg" ? (
                <>Хората зад <span className="text-white">резултатите</span></>
              ) : (
                <>The people behind the <span className="text-white">results</span></>
              )}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {teamMembers.map((m, i) => (
              <ScrollReveal
                key={m.name}
                delay={i * 80}
                className="group rounded-2xl bg-brand-surface/70 border border-brand-border overflow-hidden bento-cell card-glow"
              >
                <div className="aspect-[3/4] overflow-hidden relative">
                  <img
                    src={m.image}
                    alt={m.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/90 via-transparent to-transparent" />
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base md:text-lg font-bold uppercase tracking-tight">{m.name}</h3>
                  <p className="text-xs font-mono uppercase tracking-[0.2em] text-brand-purpleLight mt-1">
                    {m.role[lang]}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
